var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ModuleTable',{attrs:{"modules":_vm.workflowStore.workflows,"loading":_vm.workflowStore.areWorkflowsLoading,"no-results-content":{
      bannerLabel: 'No workflows yet, create one now',
      buttonLabel: 'New Workflow'
    }},on:{"delegate-action":_vm.handleTableAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }